import React, { useState, useEffect, useRef, useCallback } from 'react'
import PropTypes from 'prop-types'
import { View, Text } from 'react-native'
import styled from 'styled-components/native'
import Svg, { Path } from 'react-native-svg'
import Popover from 'react-native-popover-view'
import i18n from '../../../services/i18n'
import Info from './Info'
import Downloads from './Downloads'
import Profile from './Profile'

const Header = props => {
  const files = [{
    id: 1, name: 'File'
  }]

  return (
    <View style={props.style}>
      <Left>
        <LogoImage source={{ uri: props.logoUrl }} resizeMode="contain" />
      </Left>
      <Right>
        { props.isReplay ? null : <Info /> }
        <Downloads />
        <Profile />
      </Right>
    </View>
  )
}
Header.propTypes = {
}

const Left = styled.View`
  flex: 0 0 150px;
`

const Right = styled.View`
  flex: 1 1 auto;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
`

const Help = styled.View`
  margin-left: 30px;
  flex-direction: row;
  align-items: center;
`

const HelpIcon = () => (
  <Svg width="22" height="22" viewBox="0 0 22 22" fill="none">
    <Path d="M10.9997 20.1667C16.0623 20.1667 20.1663 16.0627 20.1663 11C20.1663 5.93743 16.0623 1.83337 10.9997 1.83337C5.93706 1.83337 1.83301 5.93743 1.83301 11C1.83301 16.0627 5.93706 20.1667 10.9997 20.1667Z" stroke="#272C5E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <Path d="M8.33203 8.24991C8.54754 7.63727 8.97292 7.12068 9.53282 6.79162C10.0927 6.46256 10.751 6.34227 11.3911 6.45206C12.0312 6.56186 12.6118 6.89464 13.03 7.39148C13.4483 7.88832 13.6772 8.51714 13.6762 9.16658C13.6762 10.9999 10.9262 11.9166 10.9262 11.9166" stroke="#272C5E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <Path d="M11 15.5834H11.01" stroke="#272C5E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </Svg>
)

const HelpLabel = styled.View`
  margin-left: 8px;
`

const HelpLabelText = styled.Text`
  font-size: 14px;
  color: #272C5E;
`

const Settings = styled.View`
  margin-left: 30px;
  flex-direction: row;
  align-items: center;
`

const SettingsIcon = () => (
  <Svg width="22" height="22" viewBox="0 0 22 22" fill="none">
    <Path d="M11 13.75C12.5188 13.75 13.75 12.5188 13.75 11C13.75 9.48122 12.5188 8.25 11 8.25C9.48122 8.25 8.25 9.48122 8.25 11C8.25 12.5188 9.48122 13.75 11 13.75Z" stroke="#272C5E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <Path d="M17.7837 13.75C17.6616 14.0264 17.6252 14.3331 17.6792 14.6305C17.7331 14.9279 17.8748 15.2023 18.0862 15.4183L18.1412 15.4733C18.3116 15.6436 18.4468 15.8458 18.5391 16.0683C18.6314 16.2909 18.6789 16.5294 18.6789 16.7704C18.6789 17.0113 18.6314 17.2499 18.5391 17.4724C18.4468 17.695 18.3116 17.8972 18.1412 18.0675C17.9709 18.2379 17.7687 18.3731 17.5461 18.4654C17.3236 18.5577 17.085 18.6052 16.8441 18.6052C16.6031 18.6052 16.3646 18.5577 16.142 18.4654C15.9195 18.3731 15.7173 18.2379 15.547 18.0675L15.492 18.0125C15.276 17.8011 15.0016 17.6594 14.7042 17.6055C14.4068 17.5515 14.1001 17.5879 13.8237 17.71C13.5525 17.8262 13.3213 18.0191 13.1584 18.265C12.9956 18.511 12.9082 18.7992 12.907 19.0941V19.25C12.907 19.7362 12.7138 20.2025 12.37 20.5463C12.0262 20.8901 11.5599 21.0833 11.0737 21.0833C10.5874 21.0833 10.1211 20.8901 9.7773 20.5463C9.43348 20.2025 9.24033 19.7362 9.24033 19.25V19.1675C9.23323 18.864 9.13502 18.5698 8.95846 18.3229C8.7819 18.0761 8.53517 17.8881 8.25033 17.7833C7.97384 17.6613 7.66715 17.6249 7.36979 17.6788C7.07242 17.7327 6.79803 17.8745 6.58199 18.0858L6.52699 18.1408C6.35672 18.3112 6.15453 18.4465 5.93197 18.5387C5.7094 18.631 5.47084 18.6785 5.22991 18.6785C4.98898 18.6785 4.75041 18.631 4.52785 18.5387C4.30529 18.4465 4.10309 18.3112 3.93283 18.1408C3.76237 17.9705 3.62714 17.7683 3.53488 17.5458C3.44262 17.3232 3.39513 17.0846 3.39513 16.8437C3.39513 16.6028 3.44262 16.3642 3.53488 16.1417C3.62714 15.9191 3.76237 15.7169 3.93283 15.5466L3.98783 15.4916C4.19915 15.2756 4.34091 15.0012 4.39483 14.7038C4.44875 14.4065 4.41235 14.0998 4.29033 13.8233C4.17413 13.5522 3.98118 13.3209 3.73525 13.1581C3.48932 12.9952 3.20113 12.9078 2.90616 12.9066H2.75033C2.2641 12.9066 1.79778 12.7135 1.45396 12.3697C1.11015 12.0258 0.916992 11.5595 0.916992 11.0733C0.916992 10.5871 1.11015 10.1207 1.45396 9.77693C1.79778 9.43311 2.2641 9.23996 2.75033 9.23996H2.83283C3.13624 9.23286 3.4305 9.13465 3.67735 8.95809C3.9242 8.78154 4.11223 8.5348 4.21699 8.24996C4.33901 7.97348 4.37541 7.66678 4.3215 7.36942C4.26758 7.07206 4.12582 6.79766 3.91449 6.58163L3.85949 6.52663C3.68904 6.35636 3.55381 6.15416 3.46155 5.9316C3.36929 5.70904 3.3218 5.47047 3.3218 5.22954C3.3218 4.98861 3.36929 4.75005 3.46155 4.52749C3.55381 4.30492 3.68904 4.10273 3.85949 3.93246C4.02976 3.762 4.23196 3.62678 4.45452 3.53452C4.67708 3.44226 4.91565 3.39477 5.15658 3.39477C5.3975 3.39477 5.63607 3.44226 5.85863 3.53452C6.0812 3.62678 6.28339 3.762 6.45366 3.93246L6.50866 3.98746C6.7247 4.19878 6.99909 4.34055 7.29645 4.39446C7.59381 4.44838 7.90051 4.41198 8.17699 4.28996H8.25033C8.52145 4.17376 8.75267 3.98082 8.91554 3.73489C9.07841 3.48895 9.16582 3.20076 9.16699 2.90579V2.74996C9.16699 2.26373 9.36015 1.79741 9.70396 1.4536C10.0478 1.10978 10.5141 0.916626 11.0003 0.916626C11.4866 0.916626 11.9529 1.10978 12.2967 1.4536C12.6405 1.79741 12.8337 2.26373 12.8337 2.74996V2.83246C12.8348 3.12743 12.9222 3.41562 13.0851 3.66155C13.248 3.90749 13.4792 4.10043 13.7503 4.21663C14.0268 4.33865 14.3335 4.37505 14.6309 4.32113C14.9282 4.26721 15.2026 4.12545 15.4187 3.91413L15.4737 3.85913C15.6439 3.68867 15.8461 3.55344 16.0687 3.46118C16.2912 3.36892 16.5298 3.32143 16.7707 3.32143C17.0117 3.32143 17.2502 3.36892 17.4728 3.46118C17.6954 3.55344 17.8976 3.68867 18.0678 3.85913C18.2383 4.02939 18.3735 4.23159 18.4658 4.45415C18.558 4.67672 18.6055 4.91528 18.6055 5.15621C18.6055 5.39714 18.558 5.6357 18.4658 5.85827C18.3735 6.08083 18.2383 6.28303 18.0678 6.45329L18.0128 6.50829C17.8015 6.72433 17.6597 6.99872 17.6058 7.29609C17.5519 7.59345 17.5883 7.90014 17.7103 8.17663V8.24996C17.8265 8.52108 18.0195 8.75231 18.2654 8.91518C18.5113 9.07805 18.7995 9.16545 19.0945 9.16663H19.2503C19.7366 9.16663 20.2029 9.35978 20.5467 9.7036C20.8905 10.0474 21.0837 10.5137 21.0837 11C21.0837 11.4862 20.8905 11.9525 20.5467 12.2963C20.2029 12.6401 19.7366 12.8333 19.2503 12.8333H19.1678C18.8729 12.8345 18.5847 12.9219 18.3387 13.0847C18.0928 13.2476 17.8999 13.4788 17.7837 13.75V13.75Z" stroke="#272C5E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </Svg>
)

const LogoImage = styled.Image`
  height: 30px;
  margin-left: 30px;
`

export default styled(Header)`
  flex: 0 0 74px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-right: ${props => props.sidebarVisible ? 45 : 30}px;
  z-index: 1;
`
